import {get} from 'lodash';

export default (state = {}, {metricKey, meta = {}}: any) => {
  return {
    ...state,
    metricMeta: {
      ...get(state, 'metricMeta', {}),
      [metricKey]: {
        ...get(state, `metricMeta.${metricKey}`, {}),
        ...meta,
      },
    },
  };
};
